import moment from "moment";
import { TByGameGenre } from './materialsList';
import { GAME_CATEGORY } from '@opm/components/FilterCommon/constants/games';

/**
 * 通用默认条件处理（提取公共逻辑）
 * @param id              - 配置 ID
 * @param startOffset     - start_time 向前偏移天数
 * @param defaultCategory - 默认品类，若 by_game_genre 有该品类日期则优先使用
 */
function createDealwithConfig(id: string, startOffset: number, defaultCategory?: string) {
  return (data: any) => {
    const config = data?.config?.[id];
    const hasDataDate: string | undefined = config?.has_data_date;

    // 若指定了默认品类且该品类有对应数据日期，则使用品类日期；否则回退到全局日期
    const categoryDate = defaultCategory ? config?.by_game_genre?.[defaultCategory] : undefined;
    const targetDate: string | undefined = categoryDate || hasDataDate;
    const m = moment(targetDate);

    // 将 by_game_genre 的日期值统一转为 YYYY-MM-DD 格式
    // 同时将全局 has_data_date 以 GAME_CATEGORY.ALL 为 key 注入，供 Hook 切换 All Games 时使用
    const rawByGameGenre: Record<string, string> | undefined = config?.by_game_genre;
    let byGameGenre: TByGameGenre | undefined;
    if (rawByGameGenre || hasDataDate) {
      byGameGenre = {};
      if (rawByGameGenre) {
        for (const [key, dateStr] of Object.entries(rawByGameGenre)) {
          const d = moment(dateStr);
          byGameGenre[key] = d.isValid() ? d.format('YYYY-MM-DD') : dateStr;
        }
      }
      if (hasDataDate) {
        const d = moment(hasDataDate);
        byGameGenre[GAME_CATEGORY.ALL] = d.isValid() ? d.format('YYYY-MM-DD') : hasDataDate;
      }
    }

    return {
      defaultFilter: {
        start_time: m.clone().subtract(startOffset, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end_time: m.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        date_type: 'daily',
      },
      byGameGenre,
    };
  };
}

/**
 * 竞品投放对比默认条件处理（startOffset = 0）
 * @param id              配置 ID
 * @param defaultCategory 默认品类，优先使用该品类的数据日期
 */
export const dealwithCompetitorAdComparison = (id: string, defaultCategory?: string) =>
  createDealwithConfig(id, 0, defaultCategory) as any;

/**
 * 素材热门趋势默认条件处理（startOffset = 13）
 */
export const dealwithCreativeTrends = (id: string) =>
  createDealwithConfig(id, 13) as any;